module.exports = __webpack_public_path__ + "static/media/AP.2b57e84a.svg";